import { Routes, Route, Navigate, useParams } from "react-router-dom";
import Navigation from "../../../components/Navigation/Navigation.js";
import TournamentView from "./TournamentView.js";
import { tournamentDataByCategory } from "./results.js";

const View = () => {
  const { category } = useParams();

  const [gender, distanceStr] = category.split("-distance");
  const distance = distanceStr;
  const tournamentData = tournamentDataByCategory[category];

  return <TournamentView gender={gender} distance={distance} tournamentData={tournamentData} />;
};

const Tournament = () => {
  const tabs = [
    { path: "m-distance145", label: "남_145M(Kungdo)" },
    { path: "m-distance90", label: "남_90M(TarscaShild)" },
    { path: "m-distance70", label: "남_70M(Puta)" },
    { path: "m-distance30", label: "남_30M(Zamby)" },
    { path: "f-distance145", label: "여_145M(Kungdo)" },
    { path: "f-distance90", label: "여_90M(TarscaShild)" },
    { path: "f-distance70", label: "여_70M(Puta)" },
    { path: "f-distance30", label: "여_30M(Zamby)" },
  ];

  return (
    <>
      <Navigation
        tabs={tabs}
        basePath="/game-summary/tournament"
        variant="tab"
      />

      <Routes>
        <Route path="/" element={<Navigate to="m-distance145" replace />} />
        <Route path=":category/" element={<View />} />
      </Routes>
    </>
  );
};
export default Tournament;
